<template>
    <div class="vehicle-card" @click.stop="setFilters()">
        <div class="vehicle-card__body">
            <div class="vehicle-card__body__heading">{{data.make }} {{data.range }}</div>
            <div class="vehicle-card__body__subheading">{{data.body}} | {{data.variant}}</div>

            <div class="vehicle-card__body__highlight">
                From <span class="vehicle-card__body__highlight--bold">{{combinedCost | toCurrency}} per month</span>
            </div>

            <div class="vehicle-card__image"><img :src='getImage(data)' class='img-fluid' alt='Vehicle Image'/></div>
            <hr/>
            <!--
            <div class="vehicle-card__body__content-row">
                P11D price: {{data.p11d | toCurrency}}
                <span class="info" tabindex="-1"
                     :id="data.id.toString()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg>
                </span>
            </div>
            <b-popover :target="data.id.toString()" :placement="`top`" triggers="hover focus">
                <p>P11D of the base vehicle. Any options added will increase this value.</p>
            </b-popover>
            -->
            <div class="vehicle-card__body__content-row">Initial rental payments: {{data.initial}}</div>
            <div class="vehicle-card__body__content-row">Contract length: {{data.term}} months</div>
            <div class="vehicle-card__body__content-row">Total mileage: {{data.mileage | numberFormat}}</div>
            <hr/>
            <div class="vehicle-card__body__cta">
                <p class="button button--ghost-white">Find out more</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {FINANCE_FILTER_ADVANCE, FINANCE_FILTER_MAINT, FINANCE_FILTER_MILEAGE, FINANCE_FILTER_TERM} from "../store/mutation-types";

    export default {
        name: "Card",
        props: [
            'data'
        ],
        data() {
            return {
                serviceCost: this.$store.state.SERVICE_COST
            }
        },
        computed: {
            combinedCost() {
                return this.data.finance + this.serviceCost;
            }
        },
        methods: {
            setFilters: function() {
                this.$store.commit(FINANCE_FILTER_ADVANCE, this.data.initial);
                this.$store.commit(FINANCE_FILTER_TERM, this.data.term);
                this.$store.commit(FINANCE_FILTER_MILEAGE, this.data.mileage);
                this.$store.commit(FINANCE_FILTER_MAINT, false);
                this.$tracking.logStep('View Vehicle', 'SME-Price-List:Offer:' + [this.data.make, this.data.range, this.data.body, this.data.variant, ('MY' + Math.floor(this.data.year))].join(' '));
                this.$router.push({name: 'details', params: {slug: this.data.slug}})
            },
            getImage: function(data) {
                return (!data.image) ? require('@/assets/images/default-vehicle.svg') : process.env.VUE_APP_API_BASE + process.env.VUE_APP_IMAGE_ENDPOINT + data.image
            }
        }
    }
</script>

<style scoped lang="stylus">
    .vehicle-card
        max-width 350px
        height 600px
        margin 15px auto
        min-width 317px
        padding 0
        box-shadow: 0 .2rem .5rem 0 rgba(0,0,0,0.5);
        cursor pointer

        &__image
            height 162px
            margin-top 20px

            img
                margin 0 auto
        &__body
            padding 20px 0
            margin 0 15px
            display flex
            flex-direction column
            height 100%

            hr
                margin 20px 0
                background-color #d8d8d8
                @media (max-width: 576px)
                    margin 15px 0
            &__heading
                font-size 22px
                line-height 28px
                color #004666
                font-family: "VWAGTheSansBold", Arial, sans-serif;
            &__highlight
                line-height 28px
                color #004666
                font-size 27px
                font-family: "VWAGTheSansLight", Arial, sans-serif;

                &--bold
                    font-family: "VWAGTheSansBold", Arial, sans-serif;
            &__subheading,
            &__content-row
                margin 5px 0
                font-size 18px
                line-height 28px
                color #4a4a4a

            &__subheading
                margin 10px 0

            &__cta
                width 100%
                margin-top auto

                p
                    width 100%
                    text-align center
                    margin 0
    .img-fluid
        max-height 100%
</style>